module.exports = __webpack_public_path__ + "static/media/human-assistant.6c8d108d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nadubot/human-assistant.png
// module id = 6178
// module chunks = 0